import { render, staticRenderFns } from "./HorizontalFiltersRadioField.vue?vue&type=template&id=68dda1a2&lang=pug&"
import script from "./HorizontalFiltersRadioField.vue?vue&type=script&setup=true&lang=js&"
export * from "./HorizontalFiltersRadioField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HorizontalFiltersRadioField.vue?vue&type=style&index=0&id=68dda1a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports